import { Button } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'

import { BODY_PARTS } from '../../../constants'

import { useProtocol } from '../../../hooks/useProtocol'
import { useParams } from 'react-router-dom'
import { BodyPartSelector, VERTICAL } from '../move/BodyPartSelector'
import { getPreviousPhaseUtil } from '../../../util/subject-journey'
import { useMoveSubjectBack } from '../../../hooks/useSubject'
import { FormLabel } from '../../../components/form/FormLabel'

type MovePreviousProps = {
  subjectData: any
  onClose: () => void
}

export const MovePreviousDrawer = ({ subjectData, onClose }: MovePreviousProps) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }

  const { callMoveBack, isLoading } = useMoveSubjectBack(projectId, subjectId)

  const [selectedBodyParts, setSelectedBodyParts] = useState<string>()
  const [moveBackReason, setMoveBackReason] = useState<string>('')
  const [reasonError, setReasonError] = useState<string>('')

  const { data: protocolData } = useProtocol(projectId)
  const phasesData = protocolData.phases

  /**
   *
   * THis is legacy code from the old version of the Modals - Needs cleanup
   *
   */
  const sortedPhases = phasesData
    .slice() // make a shallow copy to avoid mutating the original array
    .sort((a, b) => a.order - b.order) // sort by real 'order', we do this cuz otherwise it will be by creation in db

  const previousPhase = getPreviousPhaseUtil(sortedPhases, subjectData)

  const handleMoveBack = () => {
    if (moveBackReason.length < 6) {
      setReasonError('Please provide a reason minimum 6 characters long')
      return
    }

    const obj = {
      subjectId: subjectData._id,
      bodyPart: selectedBodyParts,
      projectId: projectId,
      reasonDescription: moveBackReason,
    }

    return callMoveBack(obj)
      .then((result) => {
        onClose()
        return result
      })
      .catch((error) => {
        console.error('Error moving subject forward:', error)
      })
  }

  const plainOptions = previousPhase.bodyParts
    ? previousPhase.bodyParts.map((item) => {
        return { bodyPart: item, label: BODY_PARTS[item] || item }
      })
    : []

  //const hasReason = moveBackReason.length < 5 ? false : true

  // const canMove = selectedBodyParts !== undefined && hasReason

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setReasonError('')
    setMoveBackReason(e.target.value)
  }

  return (
    <div className="row">
      <div className="col-12">
        <h5>Move Subject to Previous Phase</h5>
        <p className="mt-3">
          Revert the subject to the previous phase. The subject will answer the questionnaire set up for that phase.
        </p>
        <p className="mt-3 opacity-75">Please, provide a written reason for the revert action:</p>
      </div>

      {previousPhase?.bodyParts?.length > 0 ? (
        <div className="col-12">
          <BodyPartSelector
            className="row mt-5"
            bodyparts={plainOptions}
            setSelectedBodyPart={setSelectedBodyParts}
            direction={VERTICAL}
          />
        </div>
      ) : null}

      <div className="col-12 mt-3">
        <FormLabel label="Please provide a reason"></FormLabel>
        <TextArea placeholder="" rows={2} className="mt-1" onChange={handleTextChange} />
      </div>
      <div className="col-12">
        <div className="p-small text-danger">{reasonError || '\u00A0'}</div>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <Button onClick={onClose} type="default" className="me-2">
          Cancel
        </Button>

        <Button onClick={handleMoveBack} loading={isLoading} type="primary">
          Confirm move
        </Button>
      </div>
    </div>
  )
}
